module.exports = __webpack_public_path__ + "img/t4.0c4eba9d.png";